import React,{useState} from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
import { callGET, callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';

const NewForecast = (props) => {
  const [monthRecord,setMonthRecord] = useState(['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC']);
  const [querterlyRecord,setQuerterlyRecord] = useState(['Q1','Q2','Q3','Q4']);
  const [foreCastDetails,setForeCastDetails] = useState({
    territory : '',
    role : '',
    parentTerritory : '',
    selected_period : '',
    selected_year : '',
    target : '',
    hierarchy_forecasts : [],
    roles_user : []
  });
  const curState = props.curState;
  const forecastSettingsData = curState.forecastSettings;
  const windowFields = curState.windowFields;
  const forcastId = forecastSettingsData ? forecastSettingsData.id : null;
  const hasTerritory = forecastSettingsData ? forecastSettingsData.has_territory_enabled : false;
  const territoryList = curState.territoryList;
  const roleList = curState.roleList;
  const userList = curState.userList;
  const targetPeriod = forecastSettingsData ? forecastSettingsData.target_period : 0;

  const currentYear = (new Date()).getFullYear();
  let yearsList = [];
  for(let i=currentYear-1;i<=currentYear+5;i++) {
    yearsList.push(i)
  }

  const changeHandler = (e) => {
    const {name,value} = e.target;
    const data = {...foreCastDetails};
    if(name === 'territory') {
      if(value === '') {
        data['hierarchy_forecasts'] = [];
        data['parentTerritory'] = '';
      }else {
        const childterritories = JSON.parse(e.target.selectedOptions[0].getAttribute("childterritories"));  
        const parentterritory = e.target.selectedOptions[0].getAttribute("parentterritory");
        console.log(childterritories);
        let hierarchy_forecasts = [];
        
        childterritories.map((arr,i) => {
          const hierFore = {
            name : arr.territory_name,
            territory_manager_name : arr.manager_name,
            territory_manager : arr.territory_manager,
            element_id : arr.id,
            parent_id : arr.parent_territory,
            user_id : arr.territory_manager,
            is_manager : true,
            heir_target_value : '',
            user_target_value : ''
          }
          hierarchy_forecasts.push(hierFore);
        }) 
        data['hierarchy_forecasts'] = hierarchy_forecasts;
        data['parentTerritory'] = parentterritory;
      }
      
    }else if(name === 'role') {
      if(value === '') {
        data['hierarchy_forecasts'] = [];
        data['parentTerritory'] = '';
        data['roles_user'] = [];
      }else {
        // props.userList(value);
        const childroles = JSON.parse(e.target.selectedOptions[0].getAttribute("childroles"));  
        const parentterritory = e.target.selectedOptions[0].getAttribute("parentterritory");
        console.log(childroles);
        let hierarchy_forecasts = [];
        let userRoles = [];
        
        childroles.map((arr,i) => {
          const hierFore = {
            name : arr.role_name,
            territory_manager_name : arr.forecast_manager,
            territory_manager : arr.forecast_manager,
            element_id : arr.id,
            parent_id : arr.parent_id,
            user_id : '',
            is_manager : true,
            heir_target_value : '',
            user_target_value : ''
          }
          hierarchy_forecasts.push(hierFore);
        }) 
        data['hierarchy_forecasts'] = hierarchy_forecasts;
        data['parentTerritory'] = parentterritory;
        if(userList) {
          userList.map((arr,i) => {
            const val = {
              name : arr.username,
              element_id : value,
              parent_id : '',
              user_id : arr.id,
              is_manager : false,
              user_target_value : ''
            }
            userRoles.push(val);
          })
        }
        data['roles_user'] = userRoles;
      }
    }
    data[name] = value;
    console.log(data);
    setForeCastDetails(data);
  }

  const childTerritoriesChangeHandler = (e,ind) => {
    const {name,value} = e.target;
    const data = {...foreCastDetails};
    data['hierarchy_forecasts'][ind][name] = value;
    console.log(data['hierarchy_forecasts']);
    setForeCastDetails(data);
  }

  const usersChangeHandler = (e,ind) => {
    const {name,value} = e.target;
    const data = {...foreCastDetails};
    data['roles_user'][ind][name] = value;
    console.log(data['roles_user']);
    setForeCastDetails(data);
  }  

  const clearForms = () => {
    const data = {...foreCastDetails};
    data['territory'] = '';
    data['role'] = '';
    data['parentTerritory'] = '';
    data['selected_period'] = '';
    data['selected_year'] = '';
    data['target'] = '';
    data['hierarchy_forecasts'] = [];
    setForeCastDetails(data);
  }

  const saveHandler = () => {
    console.log("saveHandler");
    props.Loader();
    let hierFore = [];
    let userHier = [];
    const parentHeirFore = {
      element_id : hasTerritory ? foreCastDetails.territory : foreCastDetails.role,
      parent_id : foreCastDetails.parentTerritory,
      target_value : foreCastDetails.target
    }
    hierFore.push(parentHeirFore);
    if(Array.isArray(foreCastDetails.hierarchy_forecasts)) {
      foreCastDetails.hierarchy_forecasts.map((arr,i) => {
        const val = {
          element_id : arr.element_id,
          parent_id : arr.parent_id,
          target_value : arr.heir_target_value
        }
        if(arr.territory_manager) {
          const usrval = {
            user_id : arr.territory_manager,
            is_manager : true,
            element_id : arr.element_id,
            target_value : arr.user_target_value
          }
          userHier.push(usrval);
        }
        
        hierFore.push(val);
      })
    }

    if(Array.isArray(foreCastDetails.roles_user)) {
      foreCastDetails.roles_user.map((arr,i) => {
          const usrval = {
            user_id : arr.user_id,
            is_manager : false,
            element_id : arr.element_id,
            target_value : arr.user_target_value
          }
          userHier.push(usrval);
      })
    }

    const body = {
      selected_period : foreCastDetails.selected_period,
      selected_year : foreCastDetails.selected_year,
      hierarchy_forecasts : hierFore,
      user_forecasts : userHier
    }
    console.log(JSON.stringify(body));
    callPOST("forecasts/create",body)
      .then(response => {
        props.Loader();
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            props.succMessage(responseData.message);
            props.toggleModel();
            clearForms();
        }else {
          props.failMessage(responseData.message);
        }
      })
      .catch(err => {
        props.failMessage("Error occured");
        props.Loader();
        console.log("error occured",err);
      });
  }
    
  return (
    <Modal size="md" show={props.modelOpen} onHide={props.toggleModel}>
            <Modal.Header>
                <h5 classNameName="modal-title secondary_color pl-2" style={{"marginBottom":"0px"}}> Add Forecast </h5>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label> Choose {hasTerritory ? 'Territory' : 'Role'} </label>
                    <select className="form-control" name={hasTerritory ? 'territory' : 'role'} onChange={changeHandler} value={hasTerritory ? foreCastDetails.territory : foreCastDetails.role}>
                      <option value="">Select {hasTerritory ? 'Territory' : 'Role'}</option>
                      {
                        hasTerritory ?
                          territoryList ?
                            <option childterritories={JSON.stringify(territoryList.child_territories)} parentterritory={territoryList.parent_territory} value={territoryList.id}>{territoryList.territory_name}</option>
                          : null
                        : roleList ?
                            <option childroles={JSON.stringify(roleList.children)} parentterritory={roleList.parent_id} value={roleList.id}>{roleList.role_name}</option>
                          : null

                      }
                    </select>
                  </div>
                </div>
                

                <div className="col-12">
                  <div className="form-group">
                    <label> Choose Year </label>
                    <select value={foreCastDetails.selected_year} name="selected_year" className="form-control" onChange={changeHandler}>
                      <option value="">Select Year</option>
                      {
                        yearsList ?
                          yearsList.map((arr,i) => {
                            return <option key={i} value={arr}>{arr}</option>
                          })
                        : null
                      }
                    </select>
                  </div>
                </div> 

                <div className="col-12">
                  <div className="form-group">
                    <label className="d-block"> Choose Month </label>

                     
                    <div className="selectgroup selectgroup-secondary selectgroup-pills">
                    {
                      targetPeriod === 0 || targetPeriod === '0' ? 
                        monthRecord.map((arr,i) => {
                          return (
                            <label key={i} className="selectgroup-item" key={i}>
                              <input type="radio" name="selected_period" value={arr} className="selectgroup-input" checked={foreCastDetails.selected_period === arr ? true : false} onChange={changeHandler} />
                              <span className="selectgroup-button selectgroup-button-icon"> {arr} </span>
                            </label>
                          )
                        })
                      :
                        querterlyRecord.map((arr,i) => {
                          return (
                            <label key={i} className="selectgroup-item" key={i}>
                              <input type="radio" name="selected_period" value={arr} className="selectgroup-input" checked={foreCastDetails.selected_period === arr ? true : false} onChange={changeHandler} />
                              <span className="selectgroup-button selectgroup-button-icon"> {arr} </span>
                            </label>
                          )
                        })
                    }
                    </div>
                     
                  </div>
                </div>

              </div> 

              {
              hasTerritory ? 
                foreCastDetails.territory && foreCastDetails.selected_period !== '' && foreCastDetails.selected_year !== '' ? 
                  <div className="">
                    <div className="row">
                      <div className="col-6">
                        <div className="form-group">
                          <label> Target </label>
                          <input type="text" name="target" className="form-control" onChange={changeHandler}/>
                        </div>
                      </div>
                    </div> 

                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <h6> Target for Sub-territories </h6>
                        </div>

                        <div className="form-group">
                          <div className="table-responsive ">
                            <div className="table-scroll">
                              <table className="table mb-0">
                                 
                                <thead>
                                  <tr className="border-top"> 
                                    <th> Target Name </th>
                                    <th> Territory Target </th>
                                    <th> Manager Target </th>  
                                  </tr>
                                </thead>
                                <tbody>
                                {
                                  foreCastDetails.hierarchy_forecasts ?
                                    foreCastDetails.hierarchy_forecasts.map((arr,i) => {
                                      return (
                                        <tr>
                                          <td> 
                                            <a> 
                                              <span className="badge badge-info"> {arr.name} </span>   
                                            </a> 
                                            {
                                              arr.territory_manager_name ?
                                                arr.territory_manager_name
                                              : null
                                            } 
                                          </td>
                                          <td> 
                                            <input type="text" name="heir_target_value" className="form-control form-control-sm" onChange={e=>childTerritoriesChangeHandler(e,i)}/>  
                                          </td>
                                          <td> 
                                          {
                                            arr.territory_manager ? 
                                            <input type="text" name="user_target_value" className="form-control form-control-sm" onChange={e=>childTerritoriesChangeHandler(e,i)}/>  
                                            : null
                                          }
                                          </td> 
                                        </tr>
                                      )
                                    })
                                  : null
                                }
                                </tbody>
                                                       
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                : null
              :
              foreCastDetails.role && foreCastDetails.selected_period !== '' && foreCastDetails.selected_year !== '' ? 
                  <div className="">
                    <div className="row">
                      <div className="col-6">
                        <div className="form-group">
                          <label> Target </label>
                          <input type="text" name="target" className="form-control" onChange={changeHandler}/>
                        </div>
                      </div>
                    </div> 

                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <h6> Target for Sub Roles </h6>
                        </div>

                        <div className="form-group">
                          <div className="table-responsive ">
                            <div className="table-scroll">
                              <table className="table mb-0">
                                 
                                <thead>
                                  <tr className="border-top"> 
                                    <th> Role Name </th>
                                    <th> Role Target </th>
                                    <th> Manager Target </th>  
                                  </tr>
                                </thead>
                                <tbody>
                                {
                                  foreCastDetails.hierarchy_forecasts ?
                                    foreCastDetails.hierarchy_forecasts.map((arr,i) => {
                                      return (
                                        <tr>
                                          <td> 
                                            <a> 
                                              <span className="badge badge-info"> {arr.name} </span>   
                                            </a> 
                                            {
                                              arr.territory_manager_name ?
                                                arr.territory_manager_name
                                              : null
                                            } 
                                          </td>
                                          <td> 
                                            <input type="text" name="heir_target_value" className="form-control form-control-sm" onChange={e=>childTerritoriesChangeHandler(e,i)}/>  
                                          </td>
                                          <td> 
                                          {
                                            arr.territory_manager ? 
                                            <input type="text" name="user_target_value" className="form-control form-control-sm" onChange={e=>childTerritoriesChangeHandler(e,i)}/>  
                                            : null
                                          }
                                          </td> 
                                        </tr>
                                      )
                                    })
                                  : null
                                }
                                </tbody>
                                                       
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      foreCastDetails.roles_user ?
                        foreCastDetails.roles_user.length > 0 ?
                          <div className="row">
                            <div className="col-12">
                              <div className="form-group">
                                <h6> Target for users with this role </h6>
                              </div>

                              <div className="form-group">
                                <div className="table-responsive ">
                                  <div className="table-scroll">
                                    <table className="table mb-0">
                                       
                                      <thead>
                                        <tr className="border-top"> 
                                          <th> Name </th>
                                          <th> Target </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      {
                                        foreCastDetails.roles_user ?
                                          foreCastDetails.roles_user.map((arr,i) => {
                                            return (
                                              <tr>
                                                <td> 
                                                  <a> <span className="badge badge-info"> {arr.name} </span> </a>
                                                </td>
                                                <td> 
                                                  <input type="text" name="user_target_value" className="form-control form-control-sm" onChange={e=>usersChangeHandler(e,i)}/>  
                                                </td>
                                              </tr>
                                            )
                                          })
                                        : null
                                      }
                                      </tbody>
                                                             
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        : null
                      : null
                    }
                    
                  </div>
                : null
              }
            </Modal.Body>
            <Modal.Footer> 
                  <a onClick={props.toggleModel} className="btn btn-cancel" data-dismiss="modal"> Cancel </a> 
                  <a onClick={saveHandler} className="btn primary_bg"> Save </a>
                 
            </Modal.Footer>
    </Modal>
  );
}

export default withRouter(NewForecast);